const sort = {
  DiffSort(a, b) {
    // console.log(isNaN(a), typeof b);
    if (a === null || a === "-Infinity" || a === "NaN" || a === undefined)
      return -1;
    if (b === null || b === "-Infinity" || b === "NaN" || b === undefined)
      return 1;
    a = a.replace(/[$%,]/g, "");
    b = b.replace(/[$%,]/g, "");
    if (!isNaN(a)) {
      a = Number(a);
      b = Number(b);
    }
    // console.log(isNaN(a), typeof b);
    return a > b ? 1 : -1;
  }
};

export default sort;
